import { inventoryField, itemsCol } from '../../shared/array-types.js';
import { throwObjectUnitWeightLb, type ThrowObjectGateReaders } from './throw-object-gate.js';

type Row = Record<string, unknown>;
type Readers = { value: (row: Row, key: string) => unknown };
const fixedTypes = new Set(['furniture', 'door', 'building', 'window', 'wall', 'roof', 'floor', 'digsite', 'map_marker', 'wall_run']);
// Catalog discovery 2026-10-16: vehicle_land also includes Sled. Only the five
// wheeled templates receive the drawing allowance; names on inventory instances never decide it.
const WHEELED_VEHICLES = new Set(['118326C5-2D55-6C36-60C0-89456377CD10', 'DB5596BD-C029-E5E7-A9EB-283461998CE1',
  'F0BCA1D6-9F05-39C2-5227-982E7FE8EF5D', '9E1B210B-3A39-B015-DA51-DE2D270F59CD', '76CBD1B5-5287-95B8-9155-58200CAB8E56']);
export const wheeledDragObject = (row: Row): boolean => String(itemsCol(row, 'item_type') ?? '') === 'war_machine'
  || String(itemsCol(row, 'item_type') ?? '') === 'vehicle_land' && WHEELED_VEHICLES.has(String(itemsCol(row, 'item_id') ?? '').toUpperCase());
const number = (raw: unknown): number | null => {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (value === null || value === undefined || value === '') return null;
  return Number.isFinite(Number(value)) ? Number(value) : null;
};

export const objectDragGrossWeightLb = (row: Row, read: Readers): number => throwObjectUnitWeightLb(row,
  { ...read, inventoryField } as ThrowObjectGateReaders) * (number(inventoryField(row, 'item_qty')) ?? 1);
export const dragCapacityLb = (row: Row, read: Readers): number | null => number(read.value(row, 'creature_push_drag_lift_capacity'));
export const fixedDragObject = (row: Row, read: Readers, attached = false): boolean =>
  fixedTypes.has(String(itemsCol(row, 'item_type') ?? '').toLowerCase()) || !!number(read.value(row, 'immovable')) || attached;
